import { useContext } from 'react';
import { Caption1, Caption1Strong } from '@fluentui/react-components';
import { ArrowSync16Regular, CloudCheckmark16Regular } from '@fluentui/react-icons';

import DocumentContext from '../../contexts/DocumentContext.context';
import { useDocumentSavingStore } from '@modules/documents/stores/useDocumentSavingStore';

const DocumentSaveStatus = () => {
  const { isEdit } = useContext(DocumentContext);
  const { isSaved, isError } = useDocumentSavingStore();

  return (
    <p className="mr-2 text-neutral-600">
      {isSaved ? (
        <Caption1>
          <CloudCheckmark16Regular className="mb-1 mr-0.5" /> Saved
        </Caption1>
      ) : !isEdit ? (
        <Caption1Strong className="text-red-500">
          <ArrowSync16Regular className="mb-1 mr-0.5" /> Not saved. Reconnecting...
        </Caption1Strong>
      ) : isError ? (
        <Caption1Strong className="text-red-500">
          <ArrowSync16Regular className="mb-1 mr-0.5" /> Not saved. Please undo.
        </Caption1Strong>
      ) : (
        <Caption1>
          <ArrowSync16Regular className="mb-1 mr-0.5" /> Saving...
        </Caption1>
      )}
    </p>
  );
};

export default DocumentSaveStatus;
